/* global ReactSpringserveComponent */

angular.module("vastdesk").component("bulkFrequencyCapChangeModal", {
  bindings: {
    type: "@",
    targetTableId: "@",
  },
  template: require("../templates/bulkFrequencyCapChangeModal.html"),
  controllerAs: "$bulkFrequencyCapChangeModalCtrl",
  controller: [
    "$scope",
    "$rootScope",
    function ($scope, $rootScope) {
      // FIXME: a lot of this can be consolidated with code from bulkNameChangeModal and bulkBudgetChangeModal

      const self = this;

      this.rootId = `component-root-angular-ModalBulkFrequencyCapChange-${Math.floor(Math.random() * 2 ** 52)}`;

      this.open = false;
      this.selectedIds = [];
      this.unregisterWatcher = null;

      this.handleOpenChange = (open) => {
        self.open = open;
        $scope.$apply();
      };

      this.handleSubmit = () => {
        $scope.$apply();
        location.reload();
      };

      this.renderReactComponent = () => {
        return window.reactComponentScriptLoaded.promise.then(() => {
          ReactSpringserveComponent.renderComponent({
            componentName: 'ModalBulkFCapChange',
            rootId: self.rootId,
            componentProps: {
              open: self.open,
              onOpenChange: self.handleOpenChange,
              onSubmit: self.handleSubmit,
              type: self.type,
              selectedIds: self.selectedIds,
            },
          });
        });
      };

      this.$onInit = () => {
        self.renderReactComponent().then(() => {
          self.unregisterWatcher = $scope.$watchGroup(
            [
              '$bulkFrequencyCapChangeModalCtrl.open',
              '$bulkFrequencyCapChangeModalCtrl.selectedIds',
            ],
            ([_open, _selectedIds]) => {
              self.renderReactComponent();
            }
          );
        });
      };

      this.$onDestroy = () => {
        if (self.unregisterWatcher) {
          self.unregisterWatcher();
        }
      };

      $rootScope.$on("bulkEditBroadcast", (event, args) => {
        if (
          args.tableId === self.targetTableId &&
          args.id === "frequency_cap_change"
        ) {
          // copy the selected id array to guard against us accidentally clobbering it in a way that would break the AngularJS side
          self.selectedIds = Array.isArray(args.selectedIds)
            ? args.selectedIds.slice()
            : [];
          self.open = true;
        }
      });
    },
  ],
});
